module.exports = __webpack_public_path__ + "img/icon_close.c3b58d74.png";